/* ConfirmDialog — PS.confirm equivalent (built on Modal). Supports an optional
   mandatory reason capture (deactivation flows).

   props: open, onClose, title, body, bullets[], needReason, okLabel, danger,
          onOk(reason) — return false to keep the dialog open. */
import React, {useState, useEffect} from 'react'
import PropTypes from 'prop-types'
import WarningAmberIcon from '@mui/icons-material/WarningAmberOutlined'
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined'
import Modal from './Modal'

export default function ConfirmDialog({
  open,
  onClose,
  title = 'Confirm',
  body,
  bullets,
  needReason = false,
  okLabel,
  danger = false,
  onOk,
}) {
  const [reason, setReason] = useState('')
  const [err, setErr] = useState(false)
  useEffect(() => {
    if (open) {
      setReason('')
      setErr(false)
    }
  }, [open])

  const confirm = () => {
    if (needReason && !reason.trim()) {
      setErr(true)
      return false
    }
    if (onOk) onOk(reason.trim())
    return undefined
  }

  return (
    <Modal
      open={open}
      onClose={onClose}
      title={title}
      icon={danger ? <WarningAmberIcon fontSize='small' /> : <InfoOutlinedIcon fontSize='small' />}
      actions={[
        {label: 'Cancel', onClick: onClose},
        {label: okLabel || (needReason ? 'Deactivate' : 'Confirm'), primary: !danger, danger, onClick: confirm},
      ]}
    >
      {body ? <p>{body}</p> : null}
      {bullets && bullets.length ? (
        <ul style={{margin: '10px 0 0', paddingLeft: 18, color: 'var(--ink-2)', fontSize: 13, lineHeight: 1.7}}>
          {bullets.map((b, i) => (
            <li key={i}>{b}</li>
          ))}
        </ul>
      ) : null}
      {needReason ? (
        <div className={'field' + (err ? ' invalid' : '')} style={{margin: '16px 0 0'}}>
          <label>
            Reason for deactivation <span className='req'>*</span>
          </label>
          <textarea
            className={'input' + (err ? ' err' : '')}
            rows={3}
            value={reason}
            placeholder='e.g. Repeated SLA breaches in Q1'
            onChange={(e) => {
              setReason(e.target.value)
              if (err) setErr(false)
            }}
          />
          <div className='vmsg'>Reason is required.</div>
          <div className='help'>This action is logged with your name and timestamp.</div>
        </div>
      ) : null}
    </Modal>
  )
}

ConfirmDialog.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
  title: PropTypes.string,
  body: PropTypes.node,
  bullets: PropTypes.array,
  needReason: PropTypes.bool,
  okLabel: PropTypes.string,
  danger: PropTypes.bool,
  onOk: PropTypes.func,
}
